// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_2cq","cls2":"PodcastLibraryCarouselAd-cls2_Xlr PodcastLibraryCarouselAd-cls1_2cq"};